import { Component, inject, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { MessageDataService } from '../../services/message-details/message-details.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './app-spinner.component.html',
  styleUrl: './app-spinner.component.scss',
  standalone: false,
})
export class AppSpinnerComponent implements OnDestroy {
  // ============================================
  // Services
  // ============================================
  private readonly messageDataService = inject(MessageDataService);
  private readonly destroy$ = new Subject<void>();

  // ============================================
  // Loading State
  // ============================================
  private readonly loadingState$ = new BehaviorSubject<{
    messageLoading: boolean;
    isLoading: boolean;
  }>({
    messageLoading: false,
    isLoading: false,
  });

  // ============================================
  // Public Observables
  // ============================================
  loading$ = this.loadingState$.pipe(map((state) => state.isLoading));

  // ============================================
  // Constructor
  // ============================================
  constructor() {
    this.subscribeToLoadingStates();
  }

  // ============================================
  // Lifecycle
  // ============================================
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // ============================================
  // Subscriptions
  // ============================================
  private subscribeToLoadingStates(): void {
    this.messageDataService.messageData$
      .pipe(
        map((state) => state.isLoading),
        takeUntil(this.destroy$),
      )
      .subscribe((messageLoading) => {
        this.loadingState$.next({
          messageLoading,
          isLoading: messageLoading,
        });
      });
  }
}
